import React from 'react'
import { SearchPhraseSuggestion } from './SearchPhraseSuggestion'

const component = 'suggest'

export function SearchPhraseSuggestions({ searchSuggestions, basePath }) {
    return (
        <div className={`${component}__search-suggestions`}>
            {searchSuggestions.split(',').map((searchSuggestion, index) => (
                <SearchPhraseSuggestion
                    key={searchSuggestion + '-' + index}
                    searchSuggestion={searchSuggestion}
                    basePath={basePath}
                />
            ))}
        </div>
    )
}
